<template>
  <el-popover
    v-model="popVisible"
    placement="right"
    trigger="manual"
    width="300"
  >
    <div
      class="filter-dropdown"
      @mouseover="handleMouseOver"
      @mouseout="handleMouseOut"
    >
      <div class="dropdown-clear-item">
        <el-button
          type="text"
          size="mini"
          @click="handleSelectChange([])"
        >
          清空
        </el-button>
      </div>
      <div class="dropdown-value-box">
        <div
          v-for="key in (value || [])"
          :key="key"
          class="dropdown-value-item"
        >
          <i class="dropdown-value-item-text">{{ optionsO[key] || key }}</i>
          <i
            v-if="showValue && key !== allValue"
            class="dropdown-value-item-key"
          >
            {{ key }}
          </i>
          <i
            class="el-icon-close"
            @click="handleSelectChange(value.filter(id => id !== key))"
          />
        </div>
      </div>
    </div>
    <div
      slot="reference"
      class="dropdown-select"
      @mouseover="handleMouseOver"
      @mouseout="handleMouseOut"
    >
      <AllSelect
        :value="value"
        :class-name="className"
        :options="options"
        :placeholder="placeholder"
        :hasAll="hasAll"
        :allValue="allValue"
        :allName="allName"
        :collapseTags="collapseTags"
        :valueName="valueName"
        :labelName="labelName"
        :showValue="showValue"
        :filterable="filterable"
        :reserve-keyword="reserveKeyword"
        :filter-method="filterMethod ? handleFilterMethod : undefined"
        :remote="remote"
        :loading="loading"
        :remote-method="remoteMethod"
        :allowCreate="allowCreate"
        :style="styleValue"
        :size="size"
        @visible-change="handleVisibleChange"
        @enter="handleKeyup"
        @change="handleSelectChange"
      />
    </div>
  </el-popover>
</template>

<script>
import AllSelect from './AllSelect';

export default {
  components: { AllSelect },
  props: {
    value: {
      default: () => [],
    },
    options: {
      default: () => [],
    },
    inputSize: {
      default: 'small',
    },
    placeholder: {
      default: '请选择',
    },
    filterable: {
      default: true,
    },
    filterMethod: {
      default: null,
    },
    reserveKeyword: {
      default: false,
    },
    valueName: {
      default: 'id',
    },
    labelName: {
      default: 'name',
    },
    showValue: {
      default: false,
    },
    remote: {
      default: false,
    },
    loading: {
      default: false,
    },
    remoteMethod: {
      default: null,
    },
    hasAll: {
      default: true,
    },
    allValue: {
      default: '',
    },
    allName: {
      default: '全部',
    },
    styleValue: {
      default: '',
    },
    collapseTags: {
      default: true,
    },
    allowCreate: {
      default: false,
    },
    className: {
      default: '',
    },
    size: {
      default: 'small',
    },
  },
  data() {
    return {
      isFirst: true,
      popVisible: false,
      optionsO: {},
    };
  },
  created() {
    if (this.hasAll) {
      this.optionsO[this.allValue] = this.allName;
    }
  },
  methods: {
    handleFilterMethod(value) {
      this.input = value;
      this.filterMethod && this.filterMethod(value);
    },
    handleMouseOver() {
      if (this.value && this.value.length) {
        if (this.isFirst) {
          this.options.forEach((item) => {
            this.$set(
              this.optionsO,
              item[this.valueName],
              item[this.labelName],
            );
          });
          this.isFirst = false;
        }
        this.popVisible = true;
      }
    },
    handleMouseOut() {
      this.popVisible = false;
    },
    handleSelectChange(value) {
      this.options.forEach((item) => {
        if (value.includes(String(item[this.valueName]))) {
          this.$set(this.optionsO, item[this.valueName], item[this.labelName]);
        }
      });
      this.$emit('input', ...arguments);
      this.$emit('change', ...arguments);
    },
    handleKeyup() {
      this.$emit('enter');
    },
    handleVisibleChange() {
      this.$emit('visible-change', ...arguments);
    },
  },
};
</script>

<style lang="scss">
@import '~@/assets/css/filter.scss';
.filter-dropdown {
  max-height: 500px;
  overflow-y: scroll;
}
</style>
